// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_b4a3c7d5","greyText":"rdg_0796005c","priceWrapper":"rdg_c2cc75f1"};